import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { LoanService } from "../../shared/loan.service";
import { environment } from '../../../../environments/environment';
import { Loan } from "../loan";
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

@Injectable({
  providedIn: 'root'
})

export class PrintcollectionsheetService {

  LoanApprovedStatus: number = 0;  // status for approved or not.
  CollectionList: any[] = [];
  public selectedLoan: Loan;

  constructor(private httpClient: HttpClient,
    private loanService: LoanService, public datePipe: DatePipe,) {}

    getBaseUrl() {
      return environment.baseUrl;
    }

    GetCollectionSheet(rptSearchData: any) {
     
    let searchDate = new Date(rptSearchData.LoanToDate); 
      
    this.FetchCollectionSheet(rptSearchData)
      .toPromise()
      .then(data => {  
        if(data.length>0){
          // this.ReportGenerateList(data,searchDate,this.datePipe);
          // this.ReportGenerateListHtml(data,searchDate,this.datePipe);   
          // this.ReportGenerateListHtmlDEMO(data,searchDate,this.datePipe);

          this.ReportGenerateListGroupTotal(data,searchDate,this.datePipe);
        }
        else{
          console.log('data not found!');
        }
      })
      .catch(err => { console.log(err) });
    }

  FetchCollectionSheet(rptSearchData: any) {

    this.selectedLoan = new Loan();
    this.selectedLoan.ReportName = rptSearchData.ReportName;
    this.selectedLoan.ToDate = rptSearchData.LoanToDate;
    this.selectedLoan.BranchId = rptSearchData.BranchId;
    this.selectedLoan.CentreId = rptSearchData.CentreId;

    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Report', body, { headers: headers });
  }

  //--------------------------------------------------
  // Printing the documents as a lists.  
  ReportGenerateList(CollectionList,searchDate : Date,datePipe: DatePipe) {

    var generateData = function (CollectionList) {

      var result = [];
      var itemData = [{}];
      for (var i = 0; i < CollectionList.length; i += 1) {
        itemData[i] = {
          Id: CollectionList[i].Id.toString(),
          // 'No.': CollectionList[i].Id.toString(),          
          'Name': CollectionList[i].CustomerName.toString(),
          'Loan Demand': CollectionList[i].LoanDemand.toString(),
          'Previous Balance':  CollectionList[i].PreviousLoanBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
          'Loan Repay': String(' '),
          'Present Balance': CollectionList[i].PresentLoanBalance.toString(),
          'Savings Demand': CollectionList[i].SavingsDemand.toString(),
          'S. Prev Balance':   CollectionList[i].PreviousSavingsBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
          'Savings Repay': String(' '),
          'S.Presen Balance': CollectionList[i].PresentSavingsBalance.toString(),
          'Total Demand':   CollectionList[i].TotalDemand.toString(), 
          'Sign': String(' ')
        };
      }

      for (var i = 0; i < CollectionList.length; i += 1) {
        itemData[i]['Id'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }

      return result;
    };


    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {
        HeaderResult.push({
          id: HeaderName[i],
          name: HeaderName[i],
          prompt: HeaderName[i],
          width: 70,
          align: "left",
          padding: 0,
        });
      }
      return HeaderResult;
    }

    var headers = createHeaders([
      // "No.",
      "Name",
      "Loan Demand",
      "Previous Balance",
      "Loan Repay",
      "Present Balance",
      "Savings Demand",
      "S. Prev Balance",
      "Savings Repay",
      "S.Presen Balance",
      "Total Demand",
      "Sign",
    ]);

    let pdf = new jsPDF('p', 'pt', 'A4');

    pdf.setProperties({
      title: 'Collection Sheet',
      subject: 'Collection Sheet details',
      author: 'SRI',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'SRI'
    });

    var img = new Image()
    img.src = '../../assets/appimages/SRI.png'
    // var options = {orientation: 'p', unit: 'mm', format: custom};
    // var doc = new jsPDF(options);
    pdf.addImage(img, 'png', 255, 75, 50, 50);

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(12);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 210, 20);  // 40 is the height
    pdf.text("Collection Sheet", 245, 40);
    pdf.text("Statement on " +  datePipe.transform(searchDate, 'dd-MM-yyyy'), 225, 60);
    pdf.setLineWidth(1);
    pdf.line(5, 70, 590, 70)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(8);
    pdf.setFont('arial', 'normal');

    pdf.text("CENTRE NAME	:" + CollectionList[0].CentreName.toString(), 25, 80);
    pdf.text("BRANCH NAME	:" + CollectionList[0].CustomerBranchName.toString(), 25, 95);
    pdf.text("BRANCH PHONE :" + CollectionList[0].BranchPhone.toString(), 25, 110);
    pdf.text("BANK DETAIL	:" + '',  25, 125);
    pdf.text("CENTRE MANAGER :" + CollectionList[0].GroupLeaderName.toString(), 350, 80);
    pdf.text("CENTRE LEADER :" + CollectionList[0].GroupLeaderName.toString(), 350, 95)
    pdf.text("TOTAL MEMBERS :" + CollectionList.length.toString() , 350, 110);
    pdf.text("SIGNATURE :" + '' , 350, 125);

    pdf.line(5, 130, 590, 130)   // x-axis, -x-axix,  y-axis  , -y-axix
    // Top HEADER END 

    // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
    // doc.table(1, 1, generateData(100), headers, { autoSize: true });

    // Body
    pdf.table(10, 135, generateData(CollectionList), headers, { autoSize: false });
    pdf.output('dataurlnewwindow');
    // Body End
  }
  ////

  ReportGenerateListHtml(CollectionList,searchDate : Date,datePipe: DatePipe){

    var doc = new jsPDF('l', 'pt', 'letter')

    var img = new Image()
    img.src = '../../assets/appimages/SRI.png'
    var printDate = new Date();
    // var options = {orientation: 'p', unit: 'mm', format: custom};
    // var doc = new jsPDF(options);
    doc.addImage(img, 'png', 355, 75, 50, 50);

    // Top HEADER
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.setFont('arial', 'normal');
    doc.text("Society For Rural Improvements", 310, 20);  // 40 is the height
    doc.text("Collection Sheet", 345, 40);
    doc.text("Statement on " +  datePipe.transform(searchDate, 'dd-MM-yyyy'), 325, 60);
    doc.setLineWidth(1);
    doc.line(5, 70, 790, 70)
    // Top HEADER END 

    // Second Top HEADER
    doc.setFontSize(8);
    doc.setFont('arial', 'normal');

    // doc.text("Seal and Sign. of Branch Manager", 30, 80);
    // doc.text("BRANCH NAME	:" + CollectionList[0].CustomerBranchName.toString(), 30, 95);
    // doc.text("CENTRE NAME	:" + CollectionList[0].CentreName.toString(), 30, 110);
    // doc.text("Total Memebrs", 30, 125);
    // doc.text("CENTRE MANAGER :" + CollectionList[0].GroupLeaderName.toString(), 30, 140);
    // doc.text("BRANCH PHONE :" + CollectionList[0].BranchPhone.toString(), 30, 155);
    // doc.text("BANK DETAIL	:" + '',  30, 170);

    // doc.text("Printed By :" + JSON.parse(localStorage.getItem("EmployeeData"))["UserName"], 550, 80);
    // doc.text("Verified  By :" + '', 550, 95);
    // doc.text("Taken By :" + '', 550, 110);
    // doc.text("Date :" + printDate, 550, 125);
    // doc.text("Centre Leader :" + '', 550, 140);
    // doc.text("Signature :" + '', 550, 155);

    // doc.line(5, 175, 790, 175)   // x-axis, -x-axix,  y-axis  , -y-axix

// old code.
    doc.text("CENTRE NAME	:" + CollectionList[0].CentreName.toString(), 30, 80);
    doc.text("BRANCH NAME	:" + CollectionList[0].CustomerBranchName.toString(), 30, 95);
    doc.text("BRANCH PHONE :" + CollectionList[0].BranchPhone.toString(), 30, 110);
    doc.text("BANK DETAIL	:" + '',  30, 125);
    doc.text("CENTRE MANAGER :" + CollectionList[0].GroupLeaderName.toString(), 550, 80);
    doc.text("CENTRE LEADER :" + CollectionList[0].GroupLeaderName.toString(), 550, 95)
    doc.text("TOTAL MEMBERS :" + CollectionList.length.toString() , 550, 110);
    doc.text("SIGNATURE :" + '' , 550, 125);

    doc.line(5, 130, 790, 130)   // x-axis, -x-axix,  y-axis  , -y-axix

    // list item to json array
    var itemData = [];
      for (var i = 0; i < CollectionList.length; i += 1) {
        itemData[i] = {
          'No': (i+1).toString(),          
          'Name': CollectionList[i].CustomerName.toString(),
          'LoanDemand': CollectionList[i].LoanDemand.toString(),
          'PreviousBalance':  CollectionList[i].PreviousLoanBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
          'LoanRepay': String(' '),
          'PresentBalance': CollectionList[i].PresentLoanBalance.toString(),
          'SavingsDemand': CollectionList[i].SavingsDemand.toString(),
          'S_PrevBalance':   CollectionList[i].PreviousSavingsBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
          'SavingsRepay': String(' '),
          'S_PresentBalance': CollectionList[i].PresentSavingsBalance.toString(),
          'TotalDemand':   CollectionList[i].TotalDemand.toString(), 
          'Sign': String(' ')
        };
      }

      var rows = [];
      // convert json array to Array
      itemData.forEach((element,index,array) => {
        rows.push([element.No,element.Name,element.LoanDemand,element.PreviousBalance,
          element.LoanRepay,element.PresentBalance,element.SavingsDemand,
          element.S_PrevBalance,element.SavingsRepay,element.S_PresentBalance, 
          element.TotalDemand, element.Sign
        ])
      });

    var columns = [
      {title: "No", dataKey: "No"},
      {title: "Name", dataKey: "Name"},
      {title: "Loan Demand", dataKey: "LoanDemand"},
      {title: "Previous Balance", dataKey: "PreviousBalance"},
      {title: "Loan Repay", dataKey: "LoanRepay"},
      {title: "Present Balance", dataKey: "PresentBalance"},
      {title: "Savings Demand", dataKey: "SavingsDemand"},
      {title: "S. Prev Balance", dataKey: "S_PrevBalance"},
      {title: "Savings Repay", dataKey: "SavingsRepay"},
      {title: "S. Present Balance",  dataKey: "S_PresentBalance"},
      {title: "Total Demand", dataKey: "TotalDemand"},
      {title: "Sign", dataKey: "Sign"},

  ];

    var body = rows;
    // New Header and Footer Data Include the table
    var y = 5;
    doc.setLineWidth(2);
    
    autoTable(doc,{
        body: body,
        columns: columns,
        startY: 180,
        margin: {
          left: 10,
        },
        styles: {font: 'helvetica', overflow: "ellipsize",},

        // foot:[[' ', 'Price total', '130000', '  ']],
        headStyles :{textColor: [255, 255, 255], minCellHeight:30,overflow: "linebreak",},
        footStyles :{textColor: [255, 255, 255],},
        
        theme: 'grid',
        columnStyles: {
            0: {halign: 'right', cellWidth: 30,},
            1: {halign: 'left', cellWidth: 150,},
            2: {halign: 'right', cellWidth: 60,},
            3: {halign: 'right', cellWidth: 60,},
            4: {halign: 'right', cellWidth: 60,},
            5: {halign: 'left', cellWidth: 60,},
            6: {halign: 'right', cellWidth: 60,},
            7: {halign: 'right', cellWidth: 60,},
            8: {halign: 'right', cellWidth: 60,},
            9: {halign: 'left', cellWidth: 60,},
            10: {halign: 'right', cellWidth: 60,},
            11: {halign: 'right', cellWidth: 60,}
        },
})       
      doc.output('dataurlnewwindow');
  }

  //Report with Group Total
  ReportGenerateListGroupTotal(CollectionList,searchDate : Date,datePipe: DatePipe){
    
    var doc = new jsPDF('l', 'pt', 'letter')

    var img = new Image()
    img.src = '../../assets/appimages/SRI.png'

    // let printDate = datePipe.transform(new Date().toLocaleString(),'dd-MMM-yyyy HH:mm:ss')
    const date = new Date();
    const printDate = date.toLocaleString('en-US',
        { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true });

    // var options = {orientation: 'p', unit: 'mm', format: custom};
    // var doc = new jsPDF(options);
    doc.addImage(img, 'png', 355, 75, 50, 50);

    // Top HEADER
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.setFont('arial', 'normal');
    doc.text("Society For Rural Improvements", 310, 20);  // 40 is the height
    doc.text("Collection Sheet", 345, 40);
    doc.text("Statement on " +  datePipe.transform(searchDate, 'dd-MM-yyyy'), 325, 60);
    doc.setLineWidth(1);
    doc.line(5, 70, 790, 70)
    // Top HEADER END 

    // Second Top HEADER
    doc.setFontSize(8);
    doc.setFont('arial', 'normal');

    doc.text("SEAL AND SIGN. OF BRANCH MANAGER", 30, 80);
      doc.text("BRANCH NAME	: " + CollectionList[0].CustomerBranchName.toString(), 30, 95);
      doc.text("CENTRE NAME	: " + CollectionList[0].CentreName.toString(), 30, 110);
      doc.text("TOTAL MEMEBRS : " + CollectionList.length , 30, 125);
      doc.text("CENTRE MANAGER : " + CollectionList[0].GroupLeaderName.toString(), 30, 140);
      doc.text("BRANCH PHONE : " + CollectionList[0].BranchPhone.toString(), 30, 155);
      doc.text("BANK DETAIL	: " + '',  30, 170);

      doc.text("PRINTED BY : " + JSON.parse(localStorage.getItem("EmployeeData"))["UserName"], 550, 80);
      doc.text("VERIFIED  BY : " + '', 550, 95);
      doc.text("TAKEN BY : " + '', 550, 110);
      doc.text("DATE : " + printDate, 550, 125);
      doc.text("CENTRE LEADER : " + CollectionList[0].GroupLeaderName, 550, 140);
      doc.text("SIGNATURE : " + '', 550, 155);

      doc.line(5, 175, 790, 175)   // x-axis, -x-axix,  y-axis  , -y-axix

    // doc.text("CENTRE NAME	:" + CollectionList[0].CentreName.toString(), 30, 80);
    // doc.text("BRANCH NAME	:" + CollectionList[0].CustomerBranchName.toString(), 30, 95);
    // doc.text("BRANCH PHONE :" + CollectionList[0].BranchPhone.toString(), 30, 110);
    // doc.text("BANK DETAIL	:" + '',  30, 125);
    // doc.text("CENTRE MANAGER :" + CollectionList[0].GroupLeaderName.toString(), 550, 80);
    // doc.text("CENTRE LEADER :" + CollectionList[0].GroupLeaderName.toString(), 550, 95)
    // doc.text("TOTAL MEMBERS :" + CollectionList.length.toString() , 550, 110);
    // doc.text("SIGNATURE :" + '' , 550, 125);

    // doc.line(5, 130, 790, 130)   // x-axis, -x-axix,  y-axis  , -y-axix

    // Header Name rows
    function headRows() {return [{No: 'No', Name: 'Name', LoanDemand: 'Loan Demand', PreviousBalance : 'Previous Balance',
      LoanRepay :'Loan Repay', PresentBalance : 'Present Balance', SavingsDemand : 'Savings Demand', S_PrevBalance: 'S. Prev Balance',
      SavingsRepay : 'Savings Repay', S_PresentBalance : 'S. Present Balance', TotalDemand : 'Total Demand',
      Sign: 'Sign'}];}

    // list item to json array
    var itemData = [];
      for (var i = 0; i < CollectionList.length; i += 1) {
        itemData[i] = {
          'No': (i+1).toString(),          
          'Name': CollectionList[i].CustomerName.toString(),
          'LoanDemand': CollectionList[i].LoanDemand.toString(),
          'PreviousBalance':  CollectionList[i].PreviousLoanBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
          'LoanRepay': String(' '),
          'PresentBalance': CollectionList[i].PresentLoanBalance.toString(),
          'SavingsDemand': CollectionList[i].SavingsDemand.toString(),
          'S_PrevBalance':   CollectionList[i].PreviousSavingsBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
          'SavingsRepay': String(' '),
          'S_PresentBalance': CollectionList[i].PresentSavingsBalance.toString(),
          'TotalDemand':   CollectionList[i].TotalDemand.toString(), 
          'Sign': String(' '),
          'GroupId' : CollectionList[i].GroupId.toString(), 
          'GroupLoanDemand':   CollectionList[i].GroupLoanDemand.toString(), 
          'GroupSavingsDemand':   CollectionList[i].GroupSavingsDemand.toString(), 
          'GroupTotalDemand':   CollectionList[i].GroupTotalDemand.toString(), 
        };
      }

      var rows = [];
      // convert json array to Array
      itemData.forEach((element,index,array) => {
        rows.push([element.No,element.Name,element.LoanDemand,element.PreviousBalance,
          element.LoanRepay,element.PresentBalance,element.SavingsDemand,
          element.S_PrevBalance,element.SavingsRepay,element.S_PresentBalance, 
          element.TotalDemand, element.Sign,
          element.GroupLoanDemand,  element.GroupSavingsDemand,  element.GroupTotalDemand, 
        ])
      });
    
    // Table body start here
    function bodyRows(rowCount) {

        rowCount = rowCount || 10;
        let body = [];
        for (var i = 0; i < rowCount; i++) {

          if (i == 0 ){

            // printing the First Row in the table
            body.push({
                  No: (i+1).toString(),          
                  Name: CollectionList[i].CustomerName.toString(),
                  LoanDemand: CollectionList[i].LoanDemand.toString(),
                  PreviousBalance:  CollectionList[i].PreviousLoanBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
                  LoanRepay: String(' '),
                  PresentBalance: CollectionList[i].PresentLoanBalance.toString(),
                  SavingsDemand: CollectionList[i].SavingsDemand.toString(),
                  S_PrevBalance:   CollectionList[i].PreviousSavingsBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
                  SavingsRepay: String(' '),
                  S_PresentBalance: CollectionList[i].PresentSavingsBalance.toString(),
                  TotalDemand:   CollectionList[i].TotalDemand.toString(), 
                  Sign: String(' '),
                });
            }

            else{

              if(CollectionList[i-1].GroupId.toString() == CollectionList[i].GroupId.toString()){

                // printing the first row
                body.push({
                  No: (i+1).toString(),          
                  Name: CollectionList[i].CustomerName.toString(),
                  LoanDemand: CollectionList[i].LoanDemand.toString(),
                  PreviousBalance:  CollectionList[i].PreviousLoanBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
                  LoanRepay: String(' '),
                  PresentBalance: CollectionList[i].PresentLoanBalance.toString(),
                  SavingsDemand: CollectionList[i].SavingsDemand.toString(),
                  S_PrevBalance:   CollectionList[i].PreviousSavingsBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
                  SavingsRepay: String(' '),
                  S_PresentBalance: CollectionList[i].PresentSavingsBalance.toString(),
                  TotalDemand:   CollectionList[i].TotalDemand.toString(), 
                  Sign: String(' '),
                });

                if((CollectionList.length - 1) == i  ){

                  // printing the group total last row.
                  body.push({
                    No: String(' '),         
                    Name: String('   Group Total'),
                    LoanDemand: CollectionList[i].GroupLoanDemand.toString(),
                    PreviousBalance:  String(' '),
                    LoanRepay: String(' '),
                    PresentBalance: String(''),
                    SavingsDemand: CollectionList[i].GroupSavingsDemand.toString(),
                    S_PrevBalance:   String(' '),
                    SavingsRepay: String(' '),
                    S_PresentBalance: String(''),
                    TotalDemand:  CollectionList[i].GroupTotalDemand.toString(),
                    Sign: String(' '),
                  });
                }

              }

              else{
                // printing the Second row onwords
                // printing the group total row.
                body.push({
                  No: String(' '),         
                  Name: String('   Group Total' ),
                  LoanDemand: CollectionList[i-1].GroupLoanDemand.toString(),
                  PreviousBalance:  String(' '),
                  LoanRepay: String(' '),
                  PresentBalance: String(''),
                  SavingsDemand: CollectionList[i-1].GroupSavingsDemand.toString(),
                  S_PrevBalance:   String(' '),
                  SavingsRepay: String(' '),
                  S_PresentBalance: String(''),
                  TotalDemand:  CollectionList[i-1].GroupTotalDemand.toString(),
                  Sign: String(' '),
                });

                // printing current row.
                body.push({
                  No: (i+1).toString(),          
                  Name: CollectionList[i].CustomerName.toString(),
                  LoanDemand: CollectionList[i].LoanDemand.toString(),
                  PreviousBalance:  CollectionList[i].PreviousLoanBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
                  LoanRepay: String(' '),
                  PresentBalance: CollectionList[i].PresentLoanBalance.toString(),
                  SavingsDemand: CollectionList[i].SavingsDemand.toString(),
                  S_PrevBalance:   CollectionList[i].PreviousSavingsBalance.toString(), // datePipe.transform(CollectionList[i].ApplicationDate, 'dd-MM-yyyy').toString(),
                  SavingsRepay: String(' '),
                  S_PresentBalance: CollectionList[i].PresentSavingsBalance.toString(),
                  TotalDemand:   CollectionList[i].TotalDemand.toString(), 
                  Sign: String(' '),
                });

                if((CollectionList.length - 1) == i ){

                  // printing the group total last row.
                  body.push({
                    No: String(' '),         
                    Name: String('   Group Total'),
                    LoanDemand: CollectionList[i].GroupLoanDemand.toString(), // rowCount changed to i on 8/3/2024
                    PreviousBalance:  String(' '),
                    LoanRepay: String(' '),
                    PresentBalance: String(''),
                    SavingsDemand: CollectionList[i].GroupSavingsDemand.toString(), // rowCount changed to i on 8/3/2024
                    S_PrevBalance:   String(' '),
                    SavingsRepay: String(' '),
                    S_PresentBalance: String(''),
                    TotalDemand:  CollectionList[i].GroupTotalDemand.toString(), // rowCount  changed to i on 8/3/2024
                    Sign: String(' '),
                  });
                }
              }
          }
        }
        return body;
    }
    
    let head = headRows();
    
    let body = bodyRows(itemData.length);
    
    autoTable(doc,{
        startY: 180,
        margin: {
          left: 10,
        },
        head: head, //head is the header that you have created
        body: body,
        theme: 'grid', //'striped', //
        headStyles :{fillColor : [65, 105, 225]},

        columnStyles: {
          0: {halign: 'right', cellWidth: 30,},
          1: {halign: 'left', cellWidth: 150,},
          2: {halign: 'right', cellWidth: 60,},
          3: {halign: 'right', cellWidth: 60,},
          4: {halign: 'right', cellWidth: 60,},
          5: {halign: 'left', cellWidth: 60,},
          6: {halign: 'right', cellWidth: 60,},
          7: {halign: 'right', cellWidth: 60,},
          8: {halign: 'right', cellWidth: 60,},
          9: {halign: 'left', cellWidth: 60,},
          10: {halign: 'right', cellWidth: 60,},
          11: {halign: 'right', cellWidth: 60,}
      },
    });
    // return doc;
    // doc.output('dataurlnewwindow'); // commented on 20-03-2026 based on blank pdf on browser.
    // doc.save('Collection.pdf');  

    // The view logic
    const blob = doc.output('blob')
    // create a temporary URL
    const url = URL.createObjectURL(blob);
    //open in a new tab(View Mode)
    const newWindow = window.open(url, '_blank');

    //safety check for pop-up blockers
    if(!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined'){
      alert('please disable your pop-up blocker to view the PDF.')
    }

    // We use a slight delay or wait for the window to unload
    if (newWindow) {
        newWindow.onload = () => {
            // Optional: Revoke after a delay to ensure Chrome has finished rendering
            setTimeout(() => {
                URL.revokeObjectURL(url);
                console.log("Memory cleared.");
            }, 1000);
    };
}
     
  }

  // demo for group total display
  ReportGenerateListHtmlDEMO(CollectionList,searchDate : Date,datePipe: DatePipe){

    var data : any = [{
                        'item': 'keyboard',
                        'amt': '10'
                      }, {
                          'item': 'keyboard',
                          'amt': '5'
                      }, {
                          'item': 'Total',
                          'amt': '15'
                      }, {
                          'item': 'VAT',
                          'amt': '5'
                      }, {
                          'item': 'Grand Sum',
                          'amt': '15.75'
                      }];

    var doc = new jsPDF('l', 'pt', 'letter');


  function headRows() {return [{si: 'SI', item: 'item', amt: 'Amount'}];}

  function bodyRows(rowCount) {
      rowCount = rowCount || 10;
      let body = [];
      for (var j = 0; j < rowCount; j++) {

          if (j <= rowCount - 3 ) {
              body.push({
                  si: j + 1,
                  item: data[j]['item'].toString(),
                  amt: data[j]['amt']
              });
          } 
          else {
              body.push({
                  si: '',
                  item: data[j]['item'].toString(),
                  amt: data[j]['amt']
              });
          }
      }
      console.log(body)
      return body;
  }

  let head = headRows();

  let body = bodyRows(5);
  for (var i = 0; i < body.length; i++) {
      var row = body[i];
      console.log(row)
      if (i >= body.length ) {
        console.log(row[i])
          row[i]['si'] = {
              colspan: 2,
              content: body[i]['item'],
              styles: {
                  valign: 'middle',
                  halign: 'center'
              }
          };
      }
  }

  autoTable(doc,{
      startY: 60,
      head: head, //head is the header that you have created
      body: body,
      theme: 'striped'
  });
  // return doc;
  doc.output('dataurlnewwindow');

  }

}



